module.exports = __webpack_public_path__ + "static/media/attachment.53e7f395.png";